import { Error500 } from '@images';

const ErrorPage = () => (
  <div className="flex h-[calc(var(--app-vh)-83px)] flex-col items-center justify-center">
    <Error500 className="size-350" />
    <div className="mt-8 text-3xl font-bold text-content">
      Something went wrong
    </div>
  </div>
);

export default ErrorPage;
